module.exports = "<!-- COL SX -->\n<div class=\"col-md-3\">\n    <h3 class=\"boo-title\">Filters</h3>\n    <app-mss-filters></app-mss-filters>\n</div>\n<!-- END // COL SX -->\n\n<!-- COL CONTENT -->\n<div class=\"col-md-9\">\n    <h3 class=\"boo-title\">Manuscripts</h3>\n    <app-mss-filters-tags></app-mss-filters-tags>\n    <app-mss-list></app-mss-list>\n</div>\n<!-- END // COL CONTENT -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-manuscript-list/page-manuscript-list.component.html
// module id = ./src/app/components/pages/page-manuscript-list/page-manuscript-list.component.html
// module chunks = main